'use strict';

module.exports = {
  'en-US': 'United States',
  'en-AU': 'Australia',
  'pt-BR': 'Brazil',
  'en-CA': 'Canada',
  'de-DE': 'Germany',
  'es-ES': 'Spain',
  'fr-FR': 'France',
  'en-IE': 'Ireland',
  'en-IN': 'India',
  'it-IT': 'Italy',
  'en-MY': 'Malaysia',
  'nl-NL': 'Netherlands',
  'en-NZ': 'New Zealand',
  'en-PH': 'Philippines',
  'en-SG': 'Singapore',
  'en-GB': 'United Kingdom',
  'en-ZA': 'South Africa'
};